import React, { useState } from "react";
import "./COC.css";
import moment from "moment";
import { apiCall } from "../api/apiUtil";
import { useNavigate } from "react-router-dom";
import {
    Row,
    Col,
    Button,
    Card,
    Table,
    Form,
    Container,
    Modal,
    Tabs,
    Tab,
} from "react-bootstrap";
import {
    FaTachometerAlt,
    FaCalendarAlt,
    FaUsers,
    FaUser,
    FaArrowRight,
    FaSpinner,
} from "react-icons/fa"; // Import Calendar Icon
import { FaCircleStop, FaCloudArrowDown, FaHand, FaBan } from "react-icons/fa6";

const SalesCoc = () => {
    // alert(sessionStorage.getItem("Id"));
    // console.log("Id-", sessionStorage.getItem("Id"));
    const [complianceId, setComplianceId] = useState(
        sessionStorage.getItem("Id")
    );
    const [isChecked, setIsChecked] = useState(false);

    const [businessList, setBusinessList] = useState([
        { name: "", ownership: "", owner: "", relationship: "" },
    ]);
    const [globalId, setGlobalId] = useState(
        sessionStorage.getItem("globalCode")
    );
    const [year, setYear] = useState(sessionStorage.getItem("year"));
    const [month, setMonth] = useState(sessionStorage.getItem("month"));
    const [signature, setSignature] = useState("");
    const [disableSubmitButton, setDisableSubmitButton] = useState(true);
    const [formData, setFormData] = useState({
        GlobalCode: sessionStorage.getItem("globalCode"),
        EmpCode: sessionStorage.getItem("globalCode"),
        Name: sessionStorage.getItem("userName"),
        Email: sessionStorage.getItem("userEmail"),
        Department: sessionStorage.getItem("departmentName"),
        RoGlobalCode: sessionStorage.getItem("roGlobalCode"),
        RoEmail: sessionStorage.getItem("roEmail"),
        Designation: sessionStorage.getItem("designationName"),
        StartDate: moment(sessionStorage.getItem("startDate")).format("YYYY-MM-DD"),
        EndDate: moment(sessionStorage.getItem("endDate")).format("YYYY-MM-DD"),
        Year: sessionStorage.getItem("year"),
        Month: sessionStorage.getItem("month"),
        Period: sessionStorage.getItem("period"),
        // Signature: "",
        Date: moment().format("YYYY-MM-DD"),
        Place: sessionStorage.getItem("place"),
        CreatedOn: moment().format("YYYY-MM-DD HH:mm:ss"),
        Published: 0,
    });

    const [showModal, setShowModal] = useState(false);
    const [fileUploadingFlag, setFileUploadingFlag] = useState(false);

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Handle conflictStatus updates differently
        if (name === "ConflictStatus") {
            setFormData((prev) => ({
                ...prev,
                ConflictStatus: value === "1" ? 1 : 0,
            }));
        } else if (name === "BusinessinterestStatus") {
            setFormData((prev) => ({
                ...prev,
                BusinessinterestStatus: value === "1" ? 1 : 0,
            }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    
    // Handle File Upload
    //   const handleFileUpload = (event) => {
    //     const file = event.target.files[0];
    //     if (file != null) {
    //       UploadSignature(globalId, year, month, file);
    //     }
    //   };
    //   const UploadSignature = async (globalId, year, month, file) => {
    //     setFileUploadingFlag(true);
    //     const formData = new FormData();
    //     formData.append("file", file);
    //     console.log("FILE Data:", JSON.stringify(formData));
    //     const response = await apiCall(
    //       `/CodeofconductForm/UploadSignature/${globalId}/${year}/${month}`,
    //       {
    //         method: "POST",
    //         body: formData,
    //       }
    //     );
    //     setFileUploadingFlag(false);
    //     if (response?.success) {
    //       setSignature(response?.fileDetail);
    //       //   setDisableSubmitButton(false);

    //       alert("Signature Uploaded.");
    //     } else {
    //       alert("Some issue occur. Please try uploading again.");
    //     }
    //   };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isChecked === false) {
            alert("Acceptance of Code of Conduct compliance is required.");
            return;
        }

        // codeOfConductForm.Signature = JSON.stringify(signature);
        //console.log("Form Data:", JSON.stringify(formData));
        try {
            const response = await apiCall("/CodeOfConductForm/SaveSalesCodeofconduct", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response?.success) {
                alert(response?.message);
                navigate("/user-dashboard");
            } else {
                console.error("Failed to submit data");
            }
        } catch (error) {
            console.error("Error during form submission:", error);
        }
    };

    return (
        <div id="coc-form" className="d-flex flex-column min-vh-100">
            <form onSubmit={handleSubmit}>
                {/* className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-xl space-y-6"
                    className="w-full px-4 sm:px-6 lg:px-8 bg-white shadow-lg rounded-xl space-y-6" */}

                <h2 className="text-2xl font-bold text-center">
                    Sales Division — Employee Undertaking & Code of Conduct
                </h2>
                {/* <p className="text-center font-medium">
                    Code of Conduct, Ethical Business Practices Compliance, and Disclosure
                    of Conflict of Interest & Business Interests
                </p> */}

                {/* Employee Info */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="font-semibold">
                            <span style={{ color: "red" }}>*</span>Full Name:
                        </label>
                        <input
                            type="text"
                            name="Name"
                            value={formData.Name}
                            onChange={handleChange}
                            className="w-full border p-2 rounded mb-4"
                            required
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="font-semibold">
                            <span style={{ color: "red" }}>*</span>Employee ID:
                        </label>
                        <input
                            type="text"
                            name="GlobalCode"
                            value={formData.GlobalCode}
                            onChange={handleChange}
                            className="w-full border p-2 rounded mb-4"
                            required
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="font-semibold">
                            <span style={{ color: "red" }}>*</span>Designation:
                        </label>
                        <input
                            type="text"
                            name="Designation"
                            value={formData.Designation}
                            onChange={handleChange}
                            className="w-full border p-2 rounded mb-4"
                            required
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="font-semibold">
                            <span style={{ color: "red" }}>*</span>Department:
                        </label>
                        <input
                            type="text"
                            name="Department"
                            value={formData.Department}
                            onChange={handleChange}
                            className="w-full border p-2 rounded mb-4"
                            required
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="font-semibold">
                            <span style={{ color: "red" }}>*</span>Reporting Manager:
                        </label>
                        <input
                            type="text"
                            name="ROEmail"
                            value={formData.RoEmail}
                            onChange={handleChange}
                            className="w-full border p-2 rounded mb-4"
                            required
                            readOnly
                        />
                    </div>
                </div>

                {/* Sections with bullet points */}
                <div>
                    <h3 className="text-xl font-semibold mt-6">
                        Preamble
                    </h3>
                    <p>
                        This Undertaking is entered into between Jindal Steel Limited (hereinafter referred to as "the Company") and the
                        undersigned employee of the Sales Division (hereinafter referred to as "the Employee"). The Company places its trust
                        in its Sales employees to represent its commercial interests with integrity, discipline, and full accountability at all times.
                        This document sets out the binding commitments each Sales employee must adhere to as a condition of their
                        continued employment.
                    </p>
                    <h3>Commitments & Undertakings</h3>
                    <p>
                        <em>I, the undersigned Employee, hereby solemnly undertake and commit to the following:</em>
                        <ol  className="list-upper-alpha list-inside space-y-1">
                            <li>
                                <h5>Primacy of Company Interest</h5>
                                <ol className="list-decimal list-inside space-y-1">
                                    <li> 
                                        I shall at all times act in the best interest of the Company, placing the Company's commercial, financial, and
                                        reputational interests above personal convenience, peer pressure, or instructions contrary to Company policy
                                    </li>
                                    <li>
                                        I acknowledge that my role as a Sales employee is one of trust and stewardship of Company assets, pricing
                                        authority, and customer relationships, and I shall exercise this responsibility with the highest standards of integrity.
                                    </li>
                                    <li>
                                        I shall not allow personal relationships, external pressure, or inducements of any kind to influence my commercial
                                        decisions in a manner detrimental to the Company.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                <h5>Order Booking Norms & Pricing Discipline</h5>
                                <ol className="list-decimal list-inside space-y-1">
                                    <li>
                                        I shall strictly adhere to the Order Booking Norms as communicated by the Management from time to time and
                                        shall not deviate from these norms without prior written approval from the competent authority.                                        
                                    </li>
                                    <li>
                                        I shall not book any order at prices below the prevailing competition benchmark prices or at
                                        prices that are outdated / superseded, unless explicitly authorised in writing by the
                                        Management. Example: In a Rising market, order older than 15 days will not be accepted at
                                        Old Prices.
                                    </li>
                                    <li>
                                        I acknowledge that accepting or processing orders at non-current or below-competition prices without proper
                                        authorisation constitutes a serious breach of Company policy and may result in disciplinary action.
                                    </li>
                                    <li>
                                        Before finalising any order, I shall verify that the applicable pricing is current, authorised, and in conformity with the
                                        pricing guidelines in force at the time of booking.
                                    </li>
                                    <li>
                                        I will actively seek to use the correct and approved market prices which is beneficial for the
                                        company.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                <h5>Escalation of Wrongful Instructions</h5>
                                <ol className="list-decimal list-inside space-y-1">
                                    <li>
                                        If I am directed or pressured by my immediate manager or any senior in my reporting line to
                                        follow a process, practice, or pricing decision that I believe to be contrary to Company policy
                                        or these undertakings, I shall not comply with such direction silently.
                                    </li>
                                    <li>
                                        In such situations, I shall promptly escalate the matter to the next level of Management, the
                                        Head of Sales, or the Human Resources / Compliance function, whichever is most
                                        appropriate, within 24 hours of receiving such direction.
                                    </li>
                                    <li>
                                        I understand and accept that escalation in good faith is both my right and my professional
                                        duty, and that I shall not face any adverse consequence from the Company for raising such
                                        concerns in good faith.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                <h5>Reporting Wrongful or Unethical Practices</h5>
                                <ol className="list-decimal list-inside space-y-1">
                                    <li>
                                        If I become aware of any practice, transaction, or conduct by any colleague, senior, or
                                        external party that appears to be in violation of Company policy, Code of Conduct, applicable
                                        law, or ethical standards, I shall report the same to the Management, Compliance Officer, or
                                        through the Company's designated whistleblower channel without undue delay.
                                    </li>
                                    <li>
                                        I shall not be a silent party to or a participant in any transaction, arrangement, or practice that
                                        I know or reasonably suspect to be wrongful, even if instructed to do so by a superior.
                                    </li>
                                    <li>
                                        I understand that failure to report known wrongdoing may itself be treated as a violation of
                                        this Undertaking and Company policy.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                <h5>Acknowledgement of Consequences</h5>
                                <ol className="list-decimal list-inside space-y-1">
                                    <li>
                                        I understand that any breach of the commitments set out in this Undertaking may attract
                                        disciplinary action, including but not limited to formal warning, recovery of financial loss
                                        caused to the Company, suspension, or termination of employment, in accordance with the
                                        Company's HR and disciplinary policies.
                                    </li>
                                    <li>
                                        I confirm that I have read and understood all the above commitments, that I am signing this
                                        Undertaking voluntarily, and that I am fully aware of my obligations thereunder.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </p>
                    <div className="section-declaration">
                        <h3 className="text-xl text-declaration font-semibold">
                            Declaration
                        </h3>
                        <input
                            type="checkbox"
                            id="myCheckbox"
                            checked={isChecked}
                            onChange={() => setIsChecked(!isChecked)} style={{ marginTop: "15px" }}
                        />
                        I hereby declare that I have read, understood, and agree to be bound by all the commitments set
                        out in this Undertaking.
                        I confirm that this Undertaking has been signed freely, without any coercion, and that I am fully
                        aware of its legal and employment consequences.
                    </div>
                    <br />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/*<div>
            <label className="font-semibold">
              <span style={{ color: "red" }}>*</span>Upload Your Signature:
            </label>
            <input
              type="file"
              onChange={(event) => handleFileUpload(event)}
              className="w-full border p-2 rounded"
              required
            />
          </div> */}
                    <div>
                        <label className="font-semibold">
                            <span style={{ color: "red" }}>*</span>Date:
                        </label>
                        <input
                            type="date"
                            name="Date"
                            value={formData.Date}
                            onChange={handleChange}
                            className="w-full border p-2 rounded"
                            required
                            readOnly
                        />
                    </div>
                    <div>
                        <label className="font-semibold">
                            <span style={{ color: "red" }}>*</span>Place:
                        </label>
                        <input
                            type="text"
                            name="Place"
                            value={formData.Place}
                            onChange={handleChange}
                            className="w-full border p-2 rounded"
                            required
                            readOnly
                        />
                    </div>
                    <div>
                        <button
                            type="submit"
                            //   disabled={disableSubmitButton}
                            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
                            style={{marginTop: "33px"}}
                        >
                            Declare
                        </button>
                    </div>
                </div>
                {/* <button
                    type="submit"
                    //   disabled={disableSubmitButton}
                    className="mt-6 bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
                >
                    Declare
                </button>
                <button type="submit" class="btn btn-sm btn-success float-end">Submit</button> */}
            </form>
        </div>
    );
};

export default SalesCoc;
